export default {
  methods: {
    setTableHieght: function setTableHieght(val) {
      return this.$store.state.contentViewHeight - val + 'px';
    },
    handleTimeCode: function handleTimeCode() {
      var lastTime = this.$s.get('codeTime');
      var currentTime = new Date().getTime();
      if (lastTime) {
        return Math.floor(60 - (currentTime - lastTime) / 1000);
      } else {
        return 0;
      }
    },
    resetTimeCode: function resetTimeCode(fun) {
      var _this = this;
      var self = this;
      var play = setInterval(function () {
        var time = self.handleTimeCode();
        if (time <= 0) {
          clearInterval(play);
          _this.$s.remove('codeTime');
        }
        fun(time);
      }, 1000);
    }
  }
};